

var deepArtEffectsClient = apigClientFactory.newClient({
 apiKey: window.shopifySettings.deepArt_apiKey,
 accessKey: window.shopifySettings.deepArt_accessKey,
 secretKey: window.shopifySettings.deepArt_secretKey
});


var styleId;
var quality = 1980;
var optimizeForPrint = false;
var submissionId;
var resultCheck;

function applyFilter() {
    var body = { 
        'styleId': styleId,
        'imageBase64Encoded': imageBinary,
        'optimizeForPrint': false,
        'useOriginalColors': false,
        'imageSize': quality
    };

    deepArtEffectsClient.uploadPost(null, body)
        .then(function(result) {
            $('.loading-text').text('Filtre Uygulanıyor...');
            submissionId = result.data.submissionId;
            resultCheck = setInterval(imageReadyCheck, 2500);
        })
        .catch(function(error) {
            $('.loading-text').text('');
            $('#loading-overlay').hide();
            console.log('status',error.status);
            if (error && error.status === 0) {
                hideFilterContainer(); 
                document.querySelector('.image-container').style.display = 'none';
            } else {
                console.log('Error:', error);
            }
        });
}



function imageReadyCheck() {
 var params = {
     submissionId: submissionId,
 };
 deepArtEffectsClient.resultGet(params)
 .then(function(result) {
  $('.loading-text').text('Görsel Oluşturuluyor...');
  if(result.data.status=="finished") {
   // $('#customPicture').attr('src', result.data.url);
   clearInterval(resultCheck);

   $.ajax({
    url: 'https://mrpshopify.deercase.com/API/newmrpapi2.php',
    type: 'POST',
    data: {
     islemId: 2,
     imageWidth: customImageWidth,
     imageHeight: customImageHeight,
     deepUrl: result.data.url
    },
    success: function(data) {
     if(data.status == 'success') {
      $('#customPicture').attr('src', data.base64Data);
      sessionStorage.setItem('customImageData', data.base64Data);
      localStorage.setItem('customImageOrginalData', $('#orginalImage').attr('src'));
      // loadGuillotime();
     }
    }
    });
     
   $('.loading-text').text('');
   $('#loading-overlay').hide();

  }
 }).catch(function(result){
        console.log("Error checking status", result);
    });
}

document.querySelectorAll('.image-wrapper img').forEach(img => {
 img.addEventListener('click', () => {

  $('.loading-text').text('Görsel Yükleniyor...');
  $('#loading-overlay').show();
  styleId = img.getAttribute('styleId');

  if (styleId == 'orginalImage') {
    $('#customPicture').attr('src', $('#orginalImage').attr('src'));
    sessionStorage.setItem('customImageData', $('#orginalImage').attr('src'));
    localStorage.setItem('customImageOrginalData', $('#orginalImage').attr('src'));
    $('.loading-text').text('');
    $('#loading-overlay').hide();
    // loadGuillotime();
  } else {
    applyFilter();
  }

 });

});